export default "__VITE_ASSET__dc676abc__"